import React, {useState} from "react";
import { Link } from 'react-router-dom';
import {extract_Na_Ing_galeries, extract_Urls_galeriesID, compareArrays, extract_K_V_filterProduct, checkFilterImages, selectUrl_By_GaleriesCheck, validateProductData} from '../auth/elakay-utils';
import {getElakayLang} from "../auth";
import { buildProductEditPath } from "../../utils/publicIdentifier";
import imgProductLakay from '../Layout/imgs/md3.jpg';
// ViewProdTable.css: still needed as-is -- GalleryCard/RenderValue below
// keep using its .pp-* classes (pp-gcard/pp-grid-urls/pp-thumb/pp-subtable/
// pp-error-box/...), which PriProductTable.jsx ALSO relies on globally
// (same class names, no CSS module scoping) -- never rename/remove those.
// ViewProdTableRedesign.css is additive only: new pv-* classes for the
// section/row layout below, never overlapping with the pp-* ones.
import "./ViewProdTable.css";
import "./ViewProdTableRedesign.css";
import { elakayAutoText, getElakayLanguageContext } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["vIewProdTable"]?.[key] || fallback;

const etatProduit = {
  category: {
    fr: {
      texte: "Aucune catégorie n'est actuellement associée à ce produit.",
      question: "Souhaitez-vous en attribuer une afin d'optimiser son organisation et sa visibilité ?"
    },
    en: {
      texte: "No category is currently assigned to this product.",
      question: "Would you like to assign one to improve its organization and visibility?"
    },
    es: {
      texte: "Actualmente, este producto no tiene ninguna categoría asignada.",
      question: "¿Desea asignar una para optimizar su organización y visibilidad?"
    },
    ht: {
      texte: "Pwodui sa a pa gen okenn kategori asosye ak li pou kounye a.",
      question: "Èske ou ta renmen mete youn pou amelyore òganizasyon ak vizibilite li?"
    },
    pt: {
      texte: "Nenhuma categoria está atualmente associada a este produto.",
      question: "Deseja atribuir uma para otimizar sua organização e visibilidade?"
    }
  },
  filter: {
    fr: {
      texte: "Ce produit ne dispose pas encore de filtres spécifiques.",
      question: "Souhaitez-vous en définir pour faciliter la recherche et le tri ?"
    },
    en: {
      texte: "This product does not yet have specific filters.",
      question: "Would you like to define some to facilitate search and sorting?"
    },
    es: {
      texte: "Este producto aún no tiene filtros específicos.",
      question: "¿Desea definir algunos para facilitar la búsqueda y la clasificación?"
    },
    ht: {
      texte: "Pwodui sa a poko gen filtè espesifik.",
      question: "Èske ou ta renmen mete kèk filtè pou fasilite rechèch ak klasman?"
    },
    pt: {
      texte: "Este produto ainda não possui filtros específicos.",
      question: "Deseja definir alguns para facilitar a busca e a classificação?"
    }
  },
  image: {
    fr: {
      texte: "Aucune image n'est pour l'instant liée à ce produit.",
      question: "Souhaitez-vous en ajouter afin d'enrichir sa présentation visuelle ?"
    },
    en: {
      texte: "No image is currently linked to this product.",
      question: "Would you like to add one to enhance its visual presentation?"
    },
    es: {
      texte: "Actualmente, este producto no tiene ninguna imagen asociada.",
      question: "¿Desea agregar una para mejorar su presentación visual?"
    },
    ht: {
      texte: "Pwodui sa a pa gen okenn imaj asosye ak li pou kounye a.",
      question: "Èske ou ta renmen ajoute youn pou amelyore prezantasyon vizyèl li?"
    },
    pt: {
      texte: "Nenhuma imagem está atualmente vinculada a este produto.",
      question: "Deseja adicionar uma para melhorar sua apresentação visual?"
    }
  },
  combined: {
    fr: {
      texte: "Ce produit ne possède actuellement ni catégorie, ni filtre, ni image.",
      question: "Souhaitez-vous compléter ses informations pour améliorer son affichage et sa classification ?"
    },
    en: {
      texte: "This product currently has no category, filter, or image.",
      question: "Would you like to complete its information to improve its display and classification?"
    },
    es: {
      texte: "Actualmente, este producto no tiene categoría, filtro ni imagen.",
      question: "¿Desea completar la información para mejorar su visualización y clasificación?"
    },
    ht: {
      texte: "Pwodui sa a pa genyen kategori, filtè ni imaj pou kounye a.",
      question: "Èske ou ta renmen konplete enfòmasyon li pou amelyore afichaj ak klasman li?"
    },
    pt: {
      texte: "Este produto atualmente não possui categoria, filtro ou imagem.",
      question: "Deseja completar as informações para melhorar sua exibição e classificação?"
    }
  }, 
  errorFields : {
  fr: {
    texte: "Certaines lignes ou cellules sont marquées en rouge car elles contiennent des erreurs ou des informations manquantes.",
    question: "Souhaitez-vous les corriger maintenant ? Cliquez sur le bouton ci-dessous pour commencer."
  },
  en: {
    texte: "Some lines or fields are highlighted in red because they contain errors or missing information.",
    question: "Would you like to fix them now? Click the button below to start."
  },
  es: {
    texte: "Algunas líneas o campos están marcados en rojo porque contienen errores o información faltante.",
    question: "¿Desea corregirlos ahora? Haga clic en el botón de abajo para comenzar."
  },
  ht: {
    texte: "Gen kèk liy oswa chan ki make an wouj paske yo gen erè oswa enfòmasyon ki manke.",
    question: "Èske ou ta renmen korije yo kounye a? Klike sou bouton ki anba a pou kòmanse."
  },
  pt: {
    texte: "Algumas linhas ou campos estão marcados em vermelho porque contêm erros ou informações ausentes.",
    question: "Deseja corrigi-los agora? Clique no botão abaixo para começar."
  }
}
};

const fixFilterImage_GalPreview = {
  fr: {
    texte: "Il y a une petite erreur dans la galerie Preview. Vous pouvez remplacer le filtre concerné ou supprimer l'URL d'image défectueuse.",
    question: "Pour effectuer cette action, cliquez sur ce lien, puis sur le bouton « Lier l'image au filtre ».",
    link: "?addImg=true&LkIngFil=true"
  },
  en: {
    texte: "There is a small error in the gallery Preview. You can replace the affected filter or delete the defective image URL.",
    question: "To do this, click on this link, then click the \"Link Image to Filter\" button.",
    link: "?addImg=true&LkIngFil=true"
  },
  es: {
    texte: "Hay un pequeño error en la vista previa de la galería. Puede reemplazar el filtro afectado o eliminar la URL de imagen defectuosa.",
    question: "Para hacerlo, haga clic en este enlace y luego en el botón \"Vincular imagen al filtro\".",
    link: "?addImg=true&LkIngFil=true"
  },
  ht: {
    texte: "Gen yon ti erè nan aperçu galeri a. Ou kapab ranplase filtè ki gen pwoblèm nan oswa efase URL imaj ki defektye a.",
    question: "Pou fè sa, klike sou lyen sa a epi apre sa klike sou bouton « Lye imaj ak filtè a ».",
    link: "?addImg=true&LkIngFil=true"
  },
  pt: {
    texte: "Há um pequeno erro na pré-visualização da galeria. Você pode substituir o filtro afetado ou excluir o URL da imagem defeituosa.",
    question: "Para fazer isso, clique neste link e depois no botão \"Vincular imagem ao filtro\".",
    link: "?addImg=true&LkIngFil=true"
  }
};

const fixFilterProblem = {
  fr: {
    texte: "Il y a un petit problème dans les filtres. Si le nom du filtre dans les images n'existe pas dans les éléments de filtre (FilterItem), vous pouvez ajouter ce filtre dans le FilterItem ou supprimer le filtre dans l'image qui ne correspond pas. Pour les images défectueuses, vous pouvez simplement les supprimer.",
    question: "Pour effectuer cette action, cliquez sur ce lien, puis procédez à la correction.",
    link: "?preFil=true"
  },
  en: {
    texte: "There is a small problem in the filters. If the filter name in the images does not exist in the FilterItem list, you can add this filter to the FilterItem or remove the filter name from the image that does not match. For defective images, you can simply delete them.",
    question: "To fix this, click on this link, then follow the correction steps.",
    link: "?preFil=true"
  },
  es: {
    texte: "Hay un pequeño problema en los filtros. Si el nombre del filtro en las imágenes no existe en la lista de FilterItem, puede agregar ese filtro al FilterItem o eliminar el nombre del filtro en la imagen que no coincida. Para las imágenes defectuosas, simplemente puede eliminarlas.",
    question: "Para corregir esto, haga clic en este enlace y luego siga los pasos de corrección.",
    link: "?preFil=true"
  },
  ht: {
    texte: "Gen yon ti pwoblèm nan filtè yo. Si non filtè a nan imaj yo pa egziste nan lis FilterItem lan, ou ka ajoute filtè sa a nan FilterItem lan oswa efase non filtè a nan imaj la ki pa koresponn. Pou imaj ki defektye yo, ou ka senpleman efase yo.",
    question: "Pou korije pwoblèm nan, klike sou lyen sa a epi swiv etap koreksyon yo.",
    link: "?preFil=true"
  },
  pt: {
    texte: "Há um pequeno problema nos filtros. Se o nome do filtro nas imagens não existir na lista de FilterItem, você pode adicionar esse filtro ao FilterItem ou remover o nome do filtro da imagem que não corresponde. Para imagens defeituosas, basta excluí-las.",
    question: "Para corrigir isso, clique neste link e siga as etapas de correção.",
    link: "?preFil=true"
  }
};

const filterLinkError = {
  fr: {
    texte: "Cette erreur est apparue parce qu'il existe un filtre lié à une URL d'image, soit dans les filtres, soit dans la galerie Preview. Cependant, ce filtre n'est pas ou n'est plus présent dans les filtres du produit.",
    question: "Pour résoudre ce problème, vous pouvez soit ajouter le filtre manquant dans les filtres du produit (si vous possédez ce produit), soit supprimer le nom du filtre et l'URL correspondante dans le filtre ou la galerie Preview.",
    actions: {
      ajouterFiltre: {
        label: __elakayText("t006", "Ajouter le filtre manquant"),
        link: "?adFil=true"
      },
      supprimerFiltre: {
        label: __elakayText("t007", "Supprimer dans le filtre"),
        link: "?preFil=true"
      },
      supprimerGalerie: {
        label: __elakayText("t008", "Supprimer dans la galerie Preview"),
        link: "?addImg=true&LkIngFil=true"
      }
    }
  },
  en: {
    texte: "This error occurred because there is a filter linked to an image URL, either in the filters or in the gallery Preview. However, this filter is not or is no longer present in the product filters.",
    question: "To fix this issue, you can either add the missing filter to the product filters (if you own this product), or remove the filter name and its URL from the filter or gallery Preview.",
    actions: {
      ajouterFiltre: {
        label: __elakayText("t009", "Add missing filter"),
        link: "?adFil=true"
      },
      supprimerFiltre: {
        label: __elakayText("t010", "Remove from filter"),
        link: "?preFil=true"
      },
     supprimerGalerie: {
        label: __elakayText("t011", "Remove from gallery Preview"),
        link: "?addImg=true&LkIngFil=true"
      }
    }
  },
  es: {
    texte: "Este error apareció porque hay un filtro vinculado a una URL de imagen, ya sea en los filtros o en la vista previa de la galería. Sin embargo, este filtro no está o ya no está presente en los filtros del producto.",
    question: "Para resolver este problema, puede agregar el filtro que falta en los filtros del producto (si posee este producto) o eliminar el nombre del filtro y su URL del filtro o de la vista previa de la galería.",
    actions: {
      ajouterFiltre: {
        label: __elakayText("t012", "Agregar el filtro faltante"),
        link: "?adFil=true"
      },
      supprimerFiltre: {
        label: __elakayText("t013", "Eliminar en el filtro"),
        link: "?preFil=true"
      },
      supprimerGalerie: {
        label: __elakayText("t014", "Eliminar en la vista previa de la galería"),
        link: "?addImg=true&LkIngFil=true"
      }
    }
  },
  ht: {
    texte: "Erè sa a parèt paske gen yon filtè ki lye ak yon URL imaj, swa nan filtè yo oswa nan aperçu galeri a. Men filtè sa a pa egziste oswa li pa ankò nan filtè pwodwi a.",
    question: "Pou rezoud pwoblèm sa a, ou ka swa ajoute filtè ki manke a nan filtè pwodwi a (si ou gen pwodwi a), oswa efase non filtè a ak URL li nan filtè a oswa aperçu galeri a.",
    actions: {
      ajouterFiltre: {
        label: __elakayText("t015", "Ajoute filtè ki manke a"),
        link: "?adFil=true"
      },
      supprimerFiltre: {
        label: __elakayText("t016", "Efase nan filtè a"),
        link: "?preFil=true"
      },
      supprimerGalerie: {
        label: __elakayText("t017", "Efase nan aperçu galeri a"),
        link: "?addImg=true&LkIngFil=true"
      }
    }
  },
  pt: {
    texte: "Este erro ocorreu porque há um filtro vinculado a um URL de imagem, seja nos filtros ou na pré-visualização da galeria. No entanto, esse filtro não está ou não está mais presente nos filtros do produto.",
    question: "Para resolver esse problema, você pode adicionar o filtro ausente aos filtros do produto (se possuir este produto) ou remover o nome do filtro e o URL correspondente do filtro ou da pré-visualização da galeria.",
    actions: {
      ajouterFiltre: {
        label: __elakayText("t018", "Adicionar filtro ausente"),
        link: "?adFil=true"
      },
      supprimerFiltre: {
        label: __elakayText("t019", "Remover no filtro"),
        link: "?preFil=true"
      },
      supprimerGalerie: {
        label: __elakayText("t020", "Remover na pré-visualização da galeria"),
        link: "?addImg=true&LkIngFil=true"
      }
    }
  }
};


function getEtatProduitInfo(key, lang) {
  if (etatProduit[key] && etatProduit[key][lang]) {
    return {
      error : true,
      key: key,
      ...etatProduit[key][lang]
    };
  } else {
    return {
      error :false,
      key: key,
      texte: "Information non disponible.",
      question: "Langue ou clé invalide."
    };
  }
}

const isUrl = (v) => typeof v === "string" && /^https?:\/\/\S+/i.test(v);
const isImageUrl = (v) => isUrl(v) && /\.(png|jpe?g|gif|webp|svg)(\?.*)?$/i.test(v);
const isPlainObject = (v) => v && typeof v === "object" && !Array.isArray(v);
const isObjectIdLike = (v) => typeof v === "string" && /^[a-f\d]{24}$/i.test(v);

const HIDDEN_KEYS = new Set(["_id", "createdAt", "updatedAt", "__v", "experyDate", "expire"]);
const shouldOmitEntry = (k, v) =>
  HIDDEN_KEYS.has(k) || isObjectIdLike(k) || isObjectIdLike(v);

function deepClean(data) {
  if (data == null) return data;
  if (typeof data === "string") return isObjectIdLike(data) ? undefined : data;
  if (typeof data === "number" || typeof data === "boolean") return data;

  if (Array.isArray(data))
    return data?.map(deepClean).filter((v) => v !== undefined);

  if (isPlainObject(data)) {
    const out = {};
    for (const [k, raw] of Object.entries(data)) {
      if (shouldOmitEntry(k, raw)) continue;
      const v = deepClean(raw);
      if (v !== undefined) out[k] = v;
    }
    return out;
  }
  return data;
}

const getTdStatusClass = (key, allowedObjet, data = {}, checkFilImages) => {
  if (key === 'galeriesID') {
    if (!allowedObjet.galeries || !allowedObjet.galeries[0] || allowedObjet.galeries[0].urlImg?.length === 0) {
      return 'pp-td-error';
    }
  } else if (["categoriesID", "filterProduct"].includes(key)) {
    if (!Array.isArray(allowedObjet) || allowedObjet?.length === 0) {
      return 'pp-td-error';
    }
  } else if (["name", "description", "price", "sellActive"].includes(key)) {
    if (data[key] === "" || data[key] === 0 || data[key]?.sell === false) {
      return 'pp-td-error';
    }
  }
  return '';
};

/** Carte spécifique { name, images:[urls] } avec name réduit + grille d'images */
function GalleryCard({ name, images = [] }) {
  const imgUrls = Array.isArray(images) ? images.filter(isUrl) : [];
  return (
    <div className="pp-gcard">
      <div className="pp-gname" title={name || ""}>{name ?? ""}</div>
      {imgUrls?.length > 0 ? (
        <div className="pp-grid-urls">
          {imgUrls?.map((u, i) => (
            <a key={i} href={u} target="_blank" rel="noreferrer" className="pp-url-cell">
              <img 
              src={u} alt="" 
              className="pp-thumb" 
               onError={event => {
                              event.target.src = imgProductLakay
                              event.onerror = null
                            }}
              />
              <span className="pp-urltext">{u}</span>
            </a>
          ))}
        </div>
      ) : (
        <div className="pp-empty-mini">{__elakayText("t001", "No image")}</div>
      )}
    </div>
  );
}

function RenderValue({ value, allowedKeys, Arr_value, Obj_allowedKeys=[], Obj_key_off = true, Obj_backgroundColor = true, Arr_allowedKeys=[], Arr_key_off = true, Arr_backgroundColor = true  }) {
  if (value == null) return <em className="pp-dim">{__elakayText("t002", "null")}</em>;
  if (typeof value === "boolean") return value ? "✅" : "❌";
  if (typeof value === "number") return value;

  if (typeof value === "string") {
    if (isUrl(value)) {
      return (
        <a href={value} target="_blank" rel="noreferrer" className="pp-link-img">
          <img
              src={value}
            alt=""
            className="pp-thumb"
             onError={event => {
                            event.target.src = imgProductLakay
                            event.onerror = null
                          }}
          />
          <span className="pp-urltext">{value}</span>
        </a>
      );
    }
    return value;
  }

  if (Array.isArray(value)) {
    if (value?.length === 0) return <span className="pp-dim">[]</span>;

    const allObjs = value.every(isPlainObject);
    const looksLikeGalleries = allObjs && value.every(
      (o) => ("name" in o) && ("images" in o) && Array.isArray(o.images)
    );
    if (looksLikeGalleries) {
      return (
        <div className="pp-glist">
          {value?.map((g, i) => (
            <GalleryCard key={i} name={g.name} images={g.images} />
          ))}
        </div>
      );
    }

    if (allObjs) {
      const headerKeys = Array.from(
        new Set(
          value.flatMap((o) => Object.keys(o).filter((k) => (Arr_allowedKeys?.length === 0 || Arr_allowedKeys.includes(k)) && !HIDDEN_KEYS.has(k) && !isObjectIdLike(k)))
        )
      );
      if (headerKeys?.length === 0) return <span className="pp-dim">[{{}}]</span>;
      return (
        <div className="pp-subtable-wrap">
          <table className="pp-subtable table table-striped">
            <thead>
              <tr>
                {headerKeys?.map((k) => (
                  <th style={{width: "170px"}} key={k} className={k === "name" ? "pp-name-col" : undefined}>
                    {k}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {value?.map((row, i) => (
                <tr key={i}>
                  {headerKeys?.map((k) => (
                    <td
                     key={k} 
                     className={k === "name" ? "pp-name-col" : undefined}
                     >
                      <RenderValue 
                      value={row[k]}
                      Arr_value ={value}
                    allowedKeys={allowedKeys}
                    Obj_allowedKeys={Obj_allowedKeys}
                    Obj_key_off ={Obj_key_off}
                    Obj_backgroundColor={Obj_backgroundColor}
                    Arr_allowedKeys={Arr_allowedKeys}
                    Arr_key_off ={Arr_key_off}
                    Arr_backgroundColor={Arr_backgroundColor}
                       />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    const allUrls = value.every((v) => typeof v === "string" && isUrl(v));
    if (allUrls) {
      return (
        <div className="pp-grid-urls">
          {value?.map((u, i) => (
            <a key={i} href={u} target="_blank" rel="noreferrer" className="pp-url-cell">
              <img
                src={u}
                alt=""
                className="pp-thumb"
                onError={event => {
                                event.target.src = imgProductLakay
                                event.onerror = null
                              }}
              />
              <span className="pp-urltext">{u}</span>
            </a>
          ))}
        </div>
      );
    }

    return (
      <ul className="pp-list">
        {value?.map((v, i) => (
          <li key={i}>
              <RenderValue value={v} />
            </li>
        ))}
      </ul>
    );
  }

  if (isPlainObject(value)) {
    const entries = Object.entries(value).filter(([k, v]) => (Obj_allowedKeys?.length === 0 || Obj_allowedKeys.includes(k)) && !shouldOmitEntry(k, v));
    if (entries?.length === 0) return <span className="pp-dim">{`{}`}</span>;
    return (
      // Wrapped in .pp-subtable-wrap (own overflow-x:auto) -- same as the
      // array-of-objects branch above. Without it, a nested object (e.g.
      // categoriesID[].catID -> {name, FeetsCategory}) had no scroll
      // container of its own and either overflowed past its row or got
      // silently clipped by an ancestor's overflow:hidden (the
      // near-empty/oversized cards + hard-truncated columns bug).
      <div className="pp-subtable-wrap">
      <table className="pp-subtable">
        <tbody>
          {entries?.map(([k, v]) => (
            <tr key={k}>
             {Obj_key_off && <th  className={k === "name" ? "pp-name-col" : undefined}>{k}</th>}
               <td
              className={k === "name" ? "pp-name-col" : undefined}
              >
                <RenderValue
                value={v}
                allowedKeys={allowedKeys}
                Obj_allowedKeys={Obj_allowedKeys}
                Obj_key_off ={Obj_key_off}
                Obj_backgroundColor={Obj_backgroundColor}
                Arr_allowedKeys={Arr_allowedKeys}
                Arr_key_off ={Arr_key_off}
                Arr_backgroundColor={Arr_backgroundColor}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    );
  }

  return JSON.stringify(value);
}

const TableView = ({ code= "en", checkingInfoMissing , data={}, allowedKeys=[], Obj_allowedKeys=[], Arr_allowedKeys=[], tilte = '🛍️ PriProduct', key_off = true, Obj_key_off = true, Arr_key_off = true, backgroundColor = true , Obj_backgroundColor = true, Arr_backgroundColor = true  })=>{
      const urls = extract_Urls_galeriesID(data?.galeriesID);
       const galeries = extract_Na_Ing_galeries(data?.galeries);  
       const K_V_filterProduct = extract_K_V_filterProduct(data?.filterProduct);
       const checkFilImages = checkFilterImages(data?.filters);
    
      const productIncomplete = !validateProductData(data);
    
      const fil_item_Incpat_FilPro_Gal  = compareArrays(K_V_filterProduct.values, galeries.names)
      const img_N_E_galeries = compareArrays(urls, galeries.images)
      const img_N_E_filterProduct = compareArrays(urls, checkFilImages.urls)
      const fil_item_Incpat_FilPro_Fil  = compareArrays(K_V_filterProduct.values, checkFilImages.filter_url)
    let checkingData = {fil_item_Incpat_FilPro_Fil, fil_item_Incpat_FilPro_Gal, productIncomplete, img_N_E_filterProduct, img_N_E_galeries, urls, galeries, K_V_filterProduct, checkFilImages}
  
    const errorLoanding =(key, _id, lang)=>{  
      const base = buildProductEditPath({}, _id);
      if(key === "galeries" && (fil_item_Incpat_FilPro_Gal.error || img_N_E_galeries.error)){
const msg = fixFilterImage_GalPreview[lang];
const params = msg.link
return (
  <div className="pp-error-box">
    <span>{msg.texte}</span><br/>
    <span>
      {msg.question}{" "}
        <Link to={`${base}${params}`}>{__elakayText("t005", "Let's go →")}</Link>
    </span>
  </div>
);
      }else if(key === 'filters' && (checkFilImages.error || img_N_E_filterProduct.error || fil_item_Incpat_FilPro_Fil.error)) {
const msg = fixFilterProblem[lang];
const params = msg.link
return (
  <div className="pp-error-box">
    <span>{msg.texte}</span><br/>
    <span> 
      {msg.question}{" "}
        <Link to={`${base}${params}`}>{__elakayText("t005", "Let's go →")}</Link>
    </span>
  </div>
);

      } else if (key === 'filterProduct'&& (fil_item_Incpat_FilPro_Gal.error || fil_item_Incpat_FilPro_Fil.error)){

const msg = filterLinkError[lang];
return (
  <div className="pp-error-box">
    <span>{msg.texte}</span><br/>
    <span>{msg.question}</span>

    <ul>
      <li>
        <Link to={`${base}${msg?.actions?.ajouterFiltre?.link}`}>
          {msg?.actions?.ajouterFiltre?.label}
          </Link>
      </li>
      <li>
        <Link to={`${base}${msg?.actions?.supprimerFiltre?.link}`}>
          {msg?.actions?.supprimerFiltre?.label}
          </Link>
      </li>
      <li>
        <Link to={`${base}${msg?.actions?.supprimerGalerie?.link}`}>
          {msg?.actions?.supprimerGalerie?.label}
          </Link>
      </li>
    </ul>
  </div>
);
    }
    }

    const showNext = (key, allowedObjet, data, checkFilImages) => {
      if (key === 'galeriesID') {
        return allowedObjet.galeries && allowedObjet.galeries[0] && allowedObjet.galeries[0].urlImg?.length > 0;
      } else if (['categoriesID', 'filterProduct'].includes(key)) {
        return Array.isArray(allowedObjet) && allowedObjet?.length > 0;
      } else if (['name', 'description', 'price', 'sellActive'].includes(key)) {
        return !(data[key] === "" || data[key] === 0 || data[key]?.sell === false);
      }
      return true;
    };

    // Rows are computed once (same allowedKeys filter as before) so the
    // section-level status pill below and each row's own status dot both
    // read from the exact same getTdStatusClass() call -- never two
    // separately-derived "is this ok" answers that could drift apart.
    const rows = Object.entries(data).filter(([key]) => allowedKeys.includes(key));
    const rowStatus = (key) => getTdStatusClass(key, data[allowedKeys[0]], data, checkFilImages) === 'pp-td-error' ? 'error' : 'ok';
    const errorCount = rows.filter(([key]) => rowStatus(key) === 'error').length;

    return (
      <section className="pv-section">
        <header className="pv-section-head">
          <h3 className="pv-section-title">{tilte}</h3>
          {errorCount > 0 ? (
            <span className="pv-pill pv-pill-error">
              ⚠ {errorCount} {errorCount > 1 ? __elakayText("t041", "issues") : __elakayText("t040", "issue")}
            </span>
          ) : (
            <span className="pv-pill pv-pill-ok">✓ {__elakayText("t042", "Complete")}</span>
          )}
        </header>

        <div className="pv-section-body">
          {rows.map(([key, value]) => {
            const status = rowStatus(key);
            return (
              <div className={`pv-row pv-row-${status}`} key={key}>
                {key_off && (
                  <div className="pv-row-key">
                    <span className={`pv-row-dot pv-row-dot-${status}`} />
                    {key}
                  </div>
                )}
                <div className="pv-row-value">
                  {errorLoanding(key, (data.publicId || data._id), code)}
                  {showNext(key, data[allowedKeys[0]], data, checkFilImages) ? (
                    <>
                      <RenderValue
                        value={value}
                        allowedKeys={key}
                        Obj_allowedKeys={Obj_allowedKeys}
                        Obj_key_off={Obj_key_off}
                        Obj_backgroundColor={Obj_backgroundColor}
                        Arr_allowedKeys={Arr_allowedKeys}
                        Arr_key_off={Arr_key_off}
                        Arr_backgroundColor={Arr_backgroundColor}
                        checkingData={checkingData}
                      />

                      {["name", "description", "price", "sellActive"].includes(key) &&
                        (data[key] === "" || data[key] === 0 || data[key]?.sell === false) &&
                        checkingInfoMissing(['0'], ['0'], ['0'], [], (data.publicId || data._id), true)}
                    </>
                  ) : (
                    key === 'galeriesID' ?
                      checkingInfoMissing(['0'], ['0'], [], ['0'], (data.publicId || data._id))
                      : key === 'categoriesID' ? checkingInfoMissing(['0'], [], ['0'], ['0'], (data.publicId || data._id))
                      : key === 'filterProduct' && checkingInfoMissing([], ['0'], ['0'], ['0'], (data.publicId || data._id))
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    );

}


    


const ViewProdTable = ({data, infoSource})=>{
  __setElakayInfoSource(infoSource);


  const [error, setError] = useState({
      error :false,
      texte: "",
      question: ""
    });

  const bntInfoEditMissing = (key, _id, mini= false) => {
  const base = buildProductEditPath({}, _id);
  const label = infoSource.laguangeElakay('Button', infoSource.languageAPI).submit;

  const params = {
    image: '?addImg=true',
    category: '?cat=true',
    filter: '?adFil=true',
    errorFields:'?info=true',
  }[key];

  if (!params) return null;

  return (
    <Link
      to={`${base}${params}`}
      className={mini?"":"w-25 my-3 py-1 btn btn-outline-dark btn-md btn-block rounded-4"}
    >
      {label}
    </Link>
  );
};

  const {obj} = getElakayLang();
   const {code }= obj

const checkingInfoMissing = (f = [], c = [], i = [], pr =[], _id, mini = false) => {
  const firstMissing = [
    { arr: c, type: 'category' },
    { arr: f, type: 'filter' },
    { arr: i, type: 'image' },
     { arr: pr, type: 'errorFields' },
  ].find(x => !Array.isArray(x.arr) || x.arr?.length === 0);

  if (!firstMissing) return null;

  const editInfo = getEtatProduitInfo(firstMissing.type, code) || {};
  const { texte, question, key } = editInfo;

  return (
    <div>
      {mini ?
       <>
       <span className="text-danger">{texte}</span><br/>
      <span className="text-danger">{question} </span>
      {bntInfoEditMissing(key, _id, mini)}
     </>
      :
       <>
       <h3 className="text-danger">{texte}</h3>
      <h6 className="text-danger">{question}</h6>
      {bntInfoEditMissing(key, _id)}
     </>}
    </div>
  );
};


    const allowedKeys = [
  "name",
  "description",
  "price",
  "salePrice",
  "costPrice",
  "Stars",
  "condition",
  "dealTodays",
  "shipping",
  "sellActive"
];

return   (  <div className="pv-modal">

    <TableView
    data ={data}
    allowedKeys={allowedKeys}
    tilte={elakayAutoText("h_5358b1419a72e3", "📦 Info Product")}
    Obj_allowedKeys={["sell"]}
    error={error}
    setError={setError}
    checkingInfoMissing ={checkingInfoMissing}
    code={code}
    />

      <TableView 
    data ={data}
    allowedKeys={["categoriesID"]}
    tilte={elakayAutoText("h_91b31cf83c2a01", "🏷️ Categories Link to your Product")}
    Obj_allowedKeys={["name", "FeetsCategory"]}
    key_off ={false}
    error={error}
    setError={setError}
     checkingInfoMissing ={checkingInfoMissing}
      code={code}
    />

   <TableView 
    data ={data}
    allowedKeys={["filterProduct"]}
    tilte={elakayAutoText("h_80291394995a78", "🔍 Filter Product")}
    Arr_allowedKeys={["quantity", "sold", "filter", "parcel", "priceFil"]}
    key_off ={false}
    error={error}
    setError={setError}
     checkingInfoMissing ={checkingInfoMissing}
      code={code}
    />
   <TableView 
    data ={data}
    allowedKeys={["filters"]}
     Arr_allowedKeys={["FilterItem", "Images", "formValueFil"]}
    tilte={elakayAutoText("h_13afde08634a74", "⚙️ Filters")}
    key_off ={false}
    error={error}
    setError={setError}
     checkingInfoMissing ={checkingInfoMissing}
      code={code}
    />
     <TableView 
    data ={data}
    allowedKeys={["galeries"]}
    tilte={elakayAutoText("h_20dae314874459", "🖼️ Galeries Preview")}
    key_off ={false}
    error={error}
    setError={setError}
     checkingInfoMissing ={checkingInfoMissing}
      code={code}
    />
      <TableView 
    data ={data}
    allowedKeys={["galeriesID"]}
    tilte={elakayAutoText("h_4fb44fa0149352", "🎨 Galeries Product")}
    key_off ={false}
    Obj_key_off={false}
    error={error}
    setError={setError}
     checkingInfoMissing ={checkingInfoMissing}
      code={code}
    />
    </div>
)
    
}

export default ViewProdTable